import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

import CompaniesPage from '../views/CompaniesPage.vue'
import CompanyDetailsPage from '../views/CompanyDetailsPage.vue'

import TempCompanyDetailsPage from '../views/TempCompanyDetailsPage.vue'
import VendorCompaniesPage from '../views/VendorCompaniesPage.vue'

import UsersPage from '../views/UsersPage.vue';

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/companies',
    name: 'Companies',
    component: CompaniesPage
  },
  {
    path: '/companies/:id',
    name: 'CompanyDetailsPage',
    component: CompanyDetailsPage
  },
  {
    path: '/tempCompanies/:id',
    name: 'TempCompanyDetailsPage',
    component: TempCompanyDetailsPage
  },
  {
    path: '/vendorCompanies',
    name: 'VendorCompaniesPage',
    component: VendorCompaniesPage
  },
  {
    path: '/users',
    name: 'UsersPage',
    component: UsersPage
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let isauth = store.getters.isLoggedIn
  if (to.name !== 'Login' && isauth === false) {
    if (from.name === 'Login') {
      next(false)
    }
    next({ path: '/login' })
  }
  else {
    next()
  }
})

export default router
